import * as $ from 'jquery';

export const ZoomImage = () => {
	$('.zoom-js').on('click', function () {
		const imgSrc = $(this).siblings('img').attr('src'); // Get thumbnail image source
		$('html,body').addClass("shadow");
		// Create the img element dynamically
		const img = $('<img>', {
			class: 'modal-content max-h-full max-w-full',
			src: imgSrc
		});

		// Display the modal and insert the dynamically created image
		const modal = $('#imageModal');
		modal.removeClass('hidden'); // Show the modal

		// Clear any previously existing image and add the new image
		modal.find('.modal-content').remove(); // Remove any existing image
		modal.append(img); // Append the new image

		// Close the modal when clicking the close button
		$('.close-modal').on('click', function () {
			$('html,body').removeClass("shadow");
			modal.addClass('hidden'); // Hide the modal
			img.remove(); // Remove the image to reset modal state
		});
	});
};
